import { useEffect, useState } from "react";

export function useOrientation() {
  const [orientation, setOrientation] = useState(() => getOrientation());

  useEffect(() => {
    const update = () => setOrientation(getOrientation());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener("change", update);
    }
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      if (window.screen?.orientation) {
        window.screen.orientation.removeEventListener("change", update);
      }
    };
  }, []);

  return orientation;
}

function getOrientation() {
  if (typeof window === "undefined") return "portrait";
  if (window.matchMedia("(orientation: landscape)").matches) return "landscape";
  return "portrait";
}

export default useOrientation;
